module.exports = __webpack_public_path__ + "media/assets/images/layout/bg_404-page-f4aa505172ef4470111c717b9c163330.jpg";